// Mock data for the SPECT LAB clone

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Pages', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Publications', href: '#publications' },
  { label: 'Newsletter', href: '#newsletter' },
  { label: 'Gallery', href: '#gallery' },
];

export const heroSlides = [
  {
    title: 'Services with Care Compassion & Conviction',
    desc: 'SPECT LAB is a proprietary organization started in the year 2001 by Dr. Shrikant Solav who holds a post graduate degree in medicine and nuclear medicine.',
    image: '/hero1.jpg',
  },
  {
    title: 'Now Introducing Sequential FUSION PET MR',
    desc: 'The term “SPECT” stands for Single Photon Emission Computerized Tomography, which is the technology used in the practice of nuclear medicine.',
    image: '/hero2.jpg',
  },
];

export const stats = [
  { value: 25, suffix: '+', label: 'Centers Across the United States' },
  { value: 18, suffix: '', label: 'Honorary Award for Best Quality Hospital' },
  { value: 15, suffix: '+', label: 'Years of working experience' },
  { value: 32, suffix: '+', label: 'Centers Across the United States' },
];

export const aboutFeatures = [
  'Emergency Team',
  'Expert Help',
  '24/7 Support',
  'Certified Specialist',
  'Fast Health Services',
];

export const services = [
  {
    name: 'PET-CT Imaging Procedure (FDG)',
    icon: 'ScanSearch',
    desc: 'Advanced PET-CT imaging using FDG tracer for cancer detection, staging, treatment monitoring, and evaluation of metabolic disorders.'
  },
  {
    name: 'Thallium Scan',
    icon: 'HeartPulse',
    desc: 'Nuclear cardiology study used to assess blood flow to the heart muscle and diagnose coronary artery disease.'
  },
  {
    name: 'Bone Scans',
    icon: 'Bone',
    desc: 'Sensitive skeletal imaging for detecting fractures, infections, arthritis, and bone metastases.'
  },
  {
    name: 'DTPA Renal Scan',
    icon: 'Droplets',
    desc: 'Functional kidney imaging that evaluates renal blood flow, function, and urinary drainage.'
  },
  {
    name: 'Thyroid Scans',
    icon: 'Activity',
    desc: 'Diagnostic thyroid imaging used to assess gland structure, function, nodules, and thyroid disorders.'
  },
  {
    name: 'Captopril Renal Scan',
    icon: 'Stethoscope',
    desc: 'Specialized renal study for diagnosing renovascular hypertension and evaluating renal artery stenosis.'
  },
  {
    name: 'Colloid Liver Scan',
    icon: 'Shield',
    desc: 'Nuclear medicine imaging of the liver and spleen to evaluate organ function, size, and focal abnormalities.'
  },
  {
    name: 'Milk Scan (GE Reflux)',
    icon: 'Baby',
    desc: 'Gastroesophageal reflux study used to detect reflux and assess gastric emptying, especially in infants and children.'
  },
  {
    name: 'MUGA Scan',
    icon: 'Heart',
    desc: 'Multigated Acquisition Scan used to measure cardiac pumping efficiency and ventricular function with high accuracy.'
  }
];

export const whyChooseTabs = [
  {
    id: 'support',
    label: 'Support',
    items: [
      { title: 'Care Coordination', desc: 'We manage referrals, scheduling, reminders, and paperwork so treatment stays organized effortlessly.' },
      { title: 'Patient Portal Access', desc: 'Securely view records, results, messages, and tasks from any device, anytime.' },
      { title: 'Pharmacy Counseling', desc: 'Dosing, timing, interactions reviewed; practical tips improve adherence and outcomes over time.' },
      { title: 'Insurance & Billing Help', desc: 'Clear estimates, benefits explanations, and claim support to avoid financial surprises later.' },
      { title: 'Telehealth & Remote Monitoring', desc: 'Virtual check-ins and connected devices catch issues early between visits for intervention.' },
      { title: 'Recovery Follow-ups', desc: 'Scheduled check-ins track symptoms and function; plans refined from real-world feedback quickly.' },
    ],
  },
  {
    id: 'patient',
    label: 'Patient Care',
    items: [
      { title: 'Personalized Care Plans', desc: 'Goals aligned with lifestyle and preferences; plans adapt as conditions change.' },
      { title: 'Clear Communication', desc: 'Plain-language explanations, visuals, and take-home notes to aid decisions and confidence.' },
      { title: 'Family Education', desc: 'Caregiver coaching with checklists, red flags, and escalation guidance for at-home safety.' },
      { title: 'Compassionate Support', desc: 'Respectful privacy-first care from check-in to follow-up across every touchpoint patients experience.' },
      { title: '24/7 Nurse Hotline', desc: 'Round-the-clock guidance for symptoms, medications, and next steps, avoiding unnecessary visits.' },
      { title: 'Continuity of Care', desc: 'Information travels with you; coordinated handoffs prevent repetition and missed details entirely.' },
    ],
  },
  {
    id: 'clinical',
    label: 'Clinical Service',
    items: [
      { title: 'Board-Certified Specialists', desc: 'Certified experts collaborate to minimize diagnostic errors and personalize treatment plans.' },
      { title: 'Same-Day Diagnostics', desc: 'Imaging and labs scheduled immediately, shortening time-to-treatment and clarifying next steps.' },
      { title: 'Clear Treatment Plans', desc: 'Stepwise plans with timelines, measurable targets, and checkpoints to track progress.' },
      { title: 'Evidence-Based Protocols', desc: 'Standardized pathways follow latest guidelines, audited regularly to ensure consistent outcomes.' },
      { title: 'Multidisciplinary Reviews', desc: 'Complex cases reviewed jointly across specialties to reduce blind spots and risk.' },
      { title: 'Medication Safety', desc: 'Interaction checks, allergy screening, and ongoing monitoring to prevent adverse medication events.' },
    ],
  },
];

export const processSteps = [
  { n: '01', title: 'Easily book your appointment anytime, anywhere.', desc: 'We warmly greet every patient and strive to make their experience positive and comfortable from start to finish.' },
  { n: '02', title: 'Meet Your Doctor and Discuss Your Health Concerns in Detail', desc: 'We warmly greet every patient and strive to make their experience positive and comfortable from start to finish.' },
  { n: '03', title: 'Receive a Personalized Health Plan Tailored to Your Needs', desc: 'We warmly greet every patient and strive to make their experience positive and comfortable from start to finish.' },
  { n: '04', title: 'Continuous Support to Help You Maintain & Improve Health', desc: 'We warmly greet every patient and strive to make their experience positive and comfortable from start to finish.' },
];

export const cases = [
  { title: 'The Role of PET-CT in Early Cancer Detection', image: '/blog1.jpg' },
  { title: 'Understanding Brain Imaging in Nuclear Medicine', image: '/blog 2.png' },
  { title: 'How SPECT-CT Enhances Diagnostic Precision', image: '/blog3.png' },
  { title: 'Preparing for Your Nuclear Medicine Scan', image: '/blog4.png' },
  { title: 'Advancements in Cardiac Imaging', image: '/blog5.png' },
  { title: 'The Future of Diagnostic Imaging', image: '/blog6.png' },
];

export const testimonials = [
  {
    name: 'Julia Anderson',
    role: 'Business Consultant',
    quote: 'Outstanding care at SPECT LAB — the doctors genuinely listen and tailor treatments to each patient’s individual needs. With prompt service, a friendly and welcoming team, and a convenient location, this clinic has become my go-to place for reliable health care.',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'David Lee',
    role: 'Software Engineer',
    quote: 'Exceptional experience at SPECT LAB. From the moment I walked in, I felt genuinely cared for. The staff were warm and professional, the doctors took time to explain every detail, and I never felt rushed.',
    avatar: 'https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Amelia Ross',
    role: 'Teacher',
    quote: 'The team at SPECT LAB made me feel comfortable right away. They listened carefully to my concerns and provided a clear, personalized treatment plan. The process was efficient, the environment spotless, and the communication excellent.',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Jonas Blue',
    role: 'Marketing Specialist',
    quote: 'From booking to consultation, everything was seamless at SPECT LAB. The staff are kind, attentive, and always willing to help. I appreciate how the doctors take the time to truly understand their patients.',
    avatar: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200&h=200&fit=crop&crop=face',
  },
];

export const doctors = [
  { name: 'Dr. Olivia Brown', specialty: 'Internal Medicine Doctor', exp: '10 year', rating: 4.9, image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&h=1000&fit=crop' },
  { name: 'Dr. Emily Carter', specialty: 'Senior Oncologist', exp: '10 year', rating: 4.9, image: 'https://images.unsplash.com/photo-1594824388853-2c5e2dabcc89?w=800&h=1000&fit=crop' },
  { name: 'Dr. James Wilson', specialty: 'Dermatologist', exp: '10 year', rating: 4.9, image: 'https://images.unsplash.com/photo-1612531386530-97286d97c2d2?w=800&h=1000&fit=crop' },
  { name: 'Dr. Daniel Park', specialty: 'Cardiac Surgery', exp: '12 year', rating: 4.9, image: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=800&h=1000&fit=crop' },
  { name: 'Dr. Maria Rossi', specialty: 'Gynecologist', exp: '9 year', rating: 4.9, image: 'https://images.unsplash.com/photo-1651008376811-b90baee60c1f?w=800&h=1000&fit=crop' },
];

export const blogPosts = [
  { date: 'Jan – March 2015  Volume V • Issue I', category: 'Publication', title: 'Case 27: How to Avert False Negative FNAC with the Help of PET Scan?', excerpt: 'This case highlights the value of PET/CT in detecting malignancy when FNAC results are falsely negative. PET imaging identified metabolically active metastatic lesions that were later confirmed histologically, guiding accurate diagnosis and management.', image: '/services/PETCT.jpg' },
  { date: 'Jan - Feb 2009', category: 'Research Update', title: 'PET in Bone infections', excerpt: 'A 32 years old gentleman complained of pain in the left hip and left thigh lasting several weeks. There was associated history of low grade fever. Plain radiograph shows minimal increase in density of the left femur.', image: '/petbone.jpg' },
  { date: 'July - Aug 2008', category: 'Clinical Insights', title: 'Assessing the efficacy of chemotherapy in osteosarcoma', excerpt: 'An important aspect of PET-CTimaging is its objective value in determining the efficacy of chemotherapy. This case highlights the importance of PET scan over and above that of conventional imaging modality such as CTscan is assessing the treatment response of tumor', image: '/chemotherapy.jpg' },
  { date: 'July - Aug 2009', category: 'Neurology', title: 'Not all multifocal lesions in a known malignancy are metastatic', excerpt: 'While on antitubercular treatment, he showed clinical improvement and a follow up PET scan revealed disappearance of pulmonary and splenic (Fig 18F) lesions and regression in lumbar vertebral lesion.', image: '/metastatic.jpg' },
  { date: 'scintillations Jan 2010', category: 'Case Study', title: 'Diagnosing skeletal fractures', excerpt: 'Plain radiograph is the first investigation to be performed so as to document skeletal fracture. In almost all the cases of displaced fractures it unmistakably clinches the diagnosis.', image: 'https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?w=900&h=600&fit=crop' }
];

export const partnerLogos = ['SANEXA', 'MEDIVA', 'THANOS', 'PULSO', 'NUVA', 'CAREX'];
